import { Stack, Tooltip, Typography } from "@mui/material";
import { useRef, type ReactNode } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { MetaDescriptorBase } from "../../../../../../../../api/types/svTypes.ts";
import MetaDragListItemIcon from "../../../common/MetaDragListItemIcon.tsx";
import { isCustomMeta } from "../utilities/metaUtils.ts";

interface Props {
  field: MetaDescriptorBase;
  caption?: string;
  children?: ReactNode;
  actions?: ReactNode;
}

const MetaFieldItem = ({ field, caption, children, actions }: Props) => {
  const rowRef = useRef<HTMLDivElement>(null);
  return (
    <Stack
      ref={rowRef}
      direction="row"
      spacing={1}
      useFlexGap
      sx={{ minWidth: 0, width: "100%", alignItems: "center" }}
    >
      <Tooltip
        placement="right"
        title={<Typography variant="caption">Drag to Move</Typography>}
        disableInteractive
        enterDelay={1000}
        enterNextDelay={1000}
        slotProps={{ popper: { anchorEl: () => rowRef.current as HTMLDivElement } }}
      >
        <Stack direction="row" spacing={1} sx={{ minWidth: 0, flexGrow: 1, alignItems: "center" }}>
          <MetaDragListItemIcon
            icon={field.icon}
            sx={(theme) => ({
              color: isCustomMeta(field) ? theme.palette.info.main : theme.palette.secondary.light,
            })}
          />
          <TypographyTooltipEllipsis
            tooltipProps={{ disableInteractive: true }}
            typographyProps={{ variant: "caption" }}
            text={caption ?? field.caption}
          />
          {children}
        </Stack>
      </Tooltip>
      {actions}
    </Stack>
  );
};

export default MetaFieldItem;
